// extracted by mini-css-extract-plugin
export default {"hospital-list":"AdminHospitalList_hospital-list__GqVp-","HospitalslistContainer":"AdminHospitalList_HospitalslistContainer__x3OTd","loader":"AdminHospitalList_loader__djrk7"};